import httpClient from '@/api/httpClient';

const getPatientSkinData = treatmentId => httpClient.get(`/api/patients/skinData/${treatmentId}`);

export { getPatientSkinData };
